import { render, staticRenderFns } from "./AllFrequentSpammers.vue?vue&type=template&id=2a0b846e&"
import script from "./AllFrequentSpammers.vue?vue&type=script&lang=js&"
export * from "./AllFrequentSpammers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports